<lds-card margin="none" *appLoad="let opportunities of opportunities$">
  <div class="activity">
    <!-- activity / header -->
    <div class="activity__header">
      <div class="activity__header-icon">
        <lds-icon name="analytics" size="md"></lds-icon>
      </div>
      <div class="activity__header-text">
        <h4>Lending Summary</h4>
        <p>Your lending activity and insights</p>
      </div>
    </div>

    <!-- activity / content -->
    <div class="activity__content">
      <div class="row">
        <div class="col activity__content__graph">
          <!-- data visualization -->
          <div class="activity__graph">
            <spark-reports-opportunities-chart
              [opportunities]="opportunities"
              (hoverIndexChange)="
                hoverIndexChanged(opportunities, $event)
              "></spark-reports-opportunities-chart>
            <div class="activity__graph-empty" *ngIf="opportunities.length === 0">
              <p>No data to display</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-auto">
          <h6 class="text-center">
            {{ period ? (period | date: 'MMM yyyy') : '&nbsp;' }}
          </h6>
          <!-- loan type insights -->
          <ul class="activity-insights">
            <ng-container *ngFor="let activity of activities">
              <lds-tooltip
                cursor="help"
                message="{{
                  activity.value || 0 | plural: (activity.loanType | loanName)
                }}">
                <li class="activity-insights__item">
                  <div class="activity-insights__item-color">
                    <hr
                      [style.backgroundColor]="activity.color"
                      [style.borderColor]="activity.color" />
                  </div>
                  <div class="activity-insights__item-icon">
                    <lds-icon
                      [name]="activity.loanType | opportunityIcon"
                      size="sm"></lds-icon>
                  </div>
                  <div class="activity-insights__item-value">
                    {{ activity.value | padding: 3:'&nbsp;' }}
                  </div>
                </li>
              </lds-tooltip>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </div>
</lds-card>
